const Privileges = [
  "None",
  "PWD",
  "Senior Citizen",
  "Indigenous",
  "Special Discount",
];

export default Privileges;
